import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { ArrowLeft } from 'lucide-react';

const RSS_LOGO = "https://customer-assets.emergentagent.com/job_199c36c2-e07b-4567-84a2-e99d8a5503d6/artifacts/c9vy7sfe_rumpun_silat_sarawak_logo_transparent_1024.png";

export const PublicFormLayout = ({ children, pageTitle = 'Pendaftaran' }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  const handlePortal = () => {
    if (user) {
      navigate(user.role === 'RSS_ADMIN' ? '/admin/dashboard' : '/school/dashboard');
    } else {
      navigate('/portal-ahli');
    }
  };

  return (
    <div
      style={{ fontFamily: "'Plus Jakarta Sans', 'Inter', system-ui, sans-serif" }}
      className="min-h-screen bg-[#F7F7F7] text-[#0B0B0B]"
    >
      {/* Accent bar */}
      <div className="h-1 bg-gradient-to-r from-[#D71920] via-[#FFD21F] to-[#D71920]" />

      {/* Header */}
      <header
        className={`sticky top-0 z-50 bg-white transition-all duration-200 ${
          scrolled ? 'shadow-sm' : 'border-b border-[#E5E5E5]'
        }`}
        data-testid="form-header"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-14 flex items-center justify-between gap-4">
          {/* Back + Logo */}
          <div className="flex items-center gap-4">
            <Link
              to="/"
              className="flex items-center gap-1.5 text-xs text-[#555] hover:text-[#D71920] transition-colors font-medium"
              data-testid="back-to-home"
            >
              <ArrowLeft size={13} /> Laman Utama
            </Link>
            <div className="h-4 w-px bg-[#E5E5E5]" />
            <Link to="/" className="flex items-center gap-2">
              <img src={RSS_LOGO} alt="RSS" className="h-7 w-7 object-contain" />
              <span className="hidden sm:block text-[12px] font-bold text-[#0B0B0B] tracking-tight">
                Rumpun Silat Sarawak
              </span>
            </Link>
          </div>

          {/* Portal Ahli */}
          <button
            onClick={handlePortal}
            className="bg-[#FFD21F] hover:bg-[#f5c800] text-[#0B0B0B] text-xs font-semibold px-4 py-2 rounded transition-colors whitespace-nowrap"
            data-testid="portal-ahli-form-btn"
          >
            {user ? 'Dashboard' : 'Portal Ahli'}
          </button>
        </div>
      </header>

      {/* Content */}
      <main>{children}</main>

      {/* Footer */}
      <footer className="bg-[#0B0B0B] text-white mt-12">
        <div className="h-0.5 bg-gradient-to-r from-[#D71920] via-[#FFD21F] to-[#D71920]" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <img src={RSS_LOGO} alt="RSS" className="h-8 w-8 object-contain" />
            <div>
              <div className="text-white font-bold text-sm leading-tight">Rumpun Silat Sarawak</div>
              <div className="text-[#FFD21F] text-[10px] tracking-widest">BERSENI BERBUDI BERBAKTI</div>
            </div>
          </div>
          <p className="text-[#555] text-xs">
            © {new Date().getFullYear()} Rumpun Silat Sarawak. Hak Cipta Terpelihara.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default PublicFormLayout;
